import { useEffect, useState } from 'react';
import Bridges from '@/services/bridges';
import useCommonParams from '@/hooks/useCommonParams';

type TUseBridgeReturn = [any];
interface IProps {
  osType: string;
  media: string;
}
const useBridge = (): TUseBridgeReturn => {
  const [bridge, setBridge] = useState(null);
  const { media, osType } = useCommonParams();

  useEffect(() => {
    const bridgeInstance = new Bridges[media](osType);
    setBridge(bridgeInstance);
  }, [media, osType]);

  return [bridge];
};

export default useBridge;
